var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-layout type-report"},[_c('main-navbar'),_c('div',{staticClass:"wrapper report",class:[{ 'nav-open': _vm.$sidebar.showSidebar }]},[_c('notifications'),_c('side-bar',{attrs:{"mini":true,"active-color":_vm.sidebarBackground,"background-image":_vm.sidebarBackgroundImage,"data-background-color":_vm.sidebarBackgroundColor}},[_c('template',{slot:"links"},[_c('div',{staticClass:"profiles"},[_c('sidebar-item',{staticClass:"sidebar-item-plus",attrs:{"link":{
              name: 'Prospect Search',
              icon: 'source',
              path: '/prospect-search',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Industry Financial',
              icon: 'card_travel',
              path: '/new-profile/industry-financial-profile',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Industry Market',
              icon: 'leaderboard',
              path: '/new-profile/industry-market-profile',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Companies',
              icon: 'business',
              path: '/company-search',
            }}}),_c('div',{staticClass:"disable"},[_c('sidebar-item',{attrs:{"link":{
                name: 'Market',
                icon: 'insights',
                path: '/',
              }}}),_c('sidebar-item',{attrs:{"link":{
                name: 'Franchise',
                icon: 'store',
                path: '/',
              }}})],1),_c('sidebar-item',{attrs:{"link":{
              name: 'Valuation Multiple',
              icon: 'addchart',
              path: '/valuation-multiple',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Financial Report',
              icon: 'text_snippet',
              path: '/create-report-format/financial',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Market Report',
              icon: 'newspaper',
              path: '/create-report-format/market',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Valuation Report',
              icon: 'request_quote',
              path: '/create-report-format/valuation',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Company Report',
              icon: 'summarize',
              path: '/create-report-format/company',
            }}})],1),_c('div',{staticClass:"section_wpr"},[_vm._v("My Data")]),_c('div',{staticClass:"profiles border-0"},[_c('sidebar-item',{attrs:{"link":{
              name: 'Prospect List',
              icon: 'format_list_bulleted',
              path: '/my-prospect-lists',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Profiles',
              icon: 'folder_open',
              path: '/my-profiles',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Reports',
              icon: 'description',
              path: '/my-reports',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Data',
              icon: 'dns',
              path: '/my-data',
            }}})],1)])],2),_c('app-side-bar',{attrs:{"mini":false,"active-color":_vm.sidebarBackground,"background-image":_vm.sidebarBackgroundImage,"data-background-color":_vm.sidebarBackgroundColor}},[_c('mobile-menu'),_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
            name: 'About the Data',
            icon: 'help',
            path: _vm.reportTypeURL + this.id + '/about-data',
            type: 'product',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Summary Scores',
            icon: 'star_half',
            path: _vm.reportTypeURL + this.id + '/summary-score',
            type: 'product',
          }}}),(!this.report.spif)?_c('div',{directives:[{name:"popover",rawName:"v-popover.right",value:({ name: 'industry-summary' }),expression:"{ name: 'industry-summary' }",modifiers:{"right":true}}]},[_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
              name: 'Industry Summary',
              icon: 'chat_bubble',
              path: _vm.reportTypeURL + this.id + '/industry-summary',
              type: 'product',
            }}})],1):_vm._e(),_c('div',{directives:[{name:"popover",rawName:"v-popover.right",value:({ name: 'balance-sheet' }),expression:"{ name: 'balance-sheet' }",modifiers:{"right":true}}]},[_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
              name: 'Financials',
              icon: 'trending_up',
              path: _vm.reportTypeURL + this.id + '/profit-loss',
              type: 'product',
            }}})],1),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Ratios',
            icon: 'scatter_plot',
            path: _vm.reportTypeURL + this.id + '/financial-ratios',
            type: 'product',
          }}}),(this.report.spif)?_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Cash Tables',
            icon: 'collections_bookmark',
            path: _vm.reportTypeURL + this.id + '/cash-tables',
            type: 'product',
          }}}):_vm._e(),_c('sidebar-item',{class:_vm.loading || this.isRetail ? 'non-subscriber' : '',attrs:{"link":{
            name: 'Valuation Multiples',
            icon: 'query_stats',
            path: !this.isRetail
              ? _vm.reportTypeURL + this.id + '/valuation-multiples'
              : this.currentPath,
            type: this.isRetail ? 'disabled' : 'product',
          }}}),_c('sidebar-item',{class:_vm.loading || this.isRetail ? 'non-subscriber' : '',attrs:{"link":{
            name: 'Customize Report',
            icon: 'tune',
            path: !this.isRetail
              ? _vm.reportTypeURL + this.id + '/customize-report'
              : this.currentPath,
            type: this.isRetail ? 'disabled' : 'product',
          }}}),_c('sidebar-item',{class:!_vm.loading ? '' : 'disabled-item',attrs:{"link":{
            name: 'Manage Inputs',
            icon: 'settings',
            path: _vm.reportTypeURL + this.id + '/manage-inputs',
            type: 'product',
          }}})],1)],2),_c('div',{staticClass:"main-panel"},[_c('div',{class:{ content: !_vm.$route.meta.hideContent }},[(!_vm.isAboutRoute)?_c('div',{staticClass:"content"},[_c('PulseLoader',{class:{ hide: !_vm.loading },attrs:{"loading":_vm.loading,"quote":"Action is the foundational key to all success","author":"Pablo Picasso","profession":"Spanish Painter","img":"picasso.jpg"}})],1):_vm._e(),_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('div',{staticClass:"row"},[(!_vm.loading || _vm.isAboutRoute)?_c('router-view',{attrs:{"headerData":_vm.headerData}}):_vm._e()],1)])],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }